export default {
    general: {
        hello: 'Ciao, {name}!',
        changeLang: 'Cambia lingua',
        close: 'chiudi',
        back: 'indietro',
        reset: 'reset'
    },

    chooseSolution: {
        // ChooseSolution
        configYourSolution: 'Configura la tua soluzione',
        configYourSolution_subtitle: `Cerca la selezione che più si avvicina alle tue esigenze, clicca sulle icone per maggiori info. {0} Alla fine del percorso potrai visualizzare e scaricare la soluzione di capitolato generata.`,
        selectWaterproofingType: 'seleziona il tipo di impermeabilizzazione',
        bitumenMembranes_title: 'membrane bituminose',
        bitumenMembranes_subtitle: 'Impermeabilizzazione con',
    },

    pathViewer: {
        // PathViewer
        solutionsFound: 'soluzioni trovate',
        questionDetails: 'Dettagli Domanda',
        answerDetails: 'Dettagli Risposta',
        summary: 'Riepilogo',
        recommendedSolution: 'Soluzione consigliata',
        repeat: 'Ripeti',
        //clickPreview: 'Clicca l\'immagine per vedere i dettagli della soluzione'
        clickPreview: 'Per accedere ai dettagli della soluzione'
    }
};


// WEBPACK FOOTER //
// ./src/lang/it.js